<template>
  <div class="pagination">
    <ul v-if="phones.length && !load">
      <li class="arrow" :class="{ 'disabled': (payload.page === 1)}"><a href="" @click.prevent="goToPrevious(number)"><span class="fi-rr-angle-left"></span></a></li>
      <li v-for="number in lastPage" :class="{ 'current': (number === payload.page)}"><a href="" @click.prevent="goToPage(number)">{{ number }}</a></li>
      <li class="arrow" :class="{ 'disabled': (payload.page === lastPage)}"><a href="" @click.prevent="goToNext(number)"><span class="fi-rr-angle-right"></span></a></li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Pagination',
  props: {
    payload: Object
  },
  computed: {
    ...mapState({
      phones: state => state.products.items,
      load: state => state.products.loading
    }),
    totalProducts () {
      let count = 0
      if(this.phones.length) count = this.phones[0].totalCount
      return count
    },
    lastPage () {
      let numberOfPages = 0

      if(this.totalProducts){
        numberOfPages = this.totalProducts / this.payload.perPage
        numberOfPages = Math.ceil(numberOfPages)
      }

      return numberOfPages
    }
  },
  methods: {
    goToPage (number){
      this.$emit('update', number)
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    goToPrevious () {
      if(this.payload.page > 1) {
        this.$emit('update', this.payload.page - 1)
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    },
    goToNext () {
      if(this.payload.page < this.lastPage) {
        this.$emit('update', this.payload.page + 1)
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    }
  }
}
</script>

<style lang="scss">
@import '../../../scss/tools/*';
@import '../../../scss/mixins/*';

.pagination{
  padding: 10px 30px 40px 30px;

  ul{
    text-align: center;

    li{
      display: inline-block;
      width: auto;
      margin: 0 3px;
      float: none;

      &.current{
        a{
          font-weight: $fontSemiBold;
          cursor: default;

          &:hover{
            color: $black;
          }
        }
      }

      &.disabled{
        opacity: 0.5;

        a{
          cursor: default;

          &:hover{
            color: $black;
          }
        }
      }

      &.arrow{
        margin: 0 8px;

        a{
          font-weight: $fontBlack;

          span{
            display: inline-block;
            @include transform(translateY(1px));
          }
        }
      }

      a{
        display: inline-block;
        color: $black;
        width: auto;
        min-width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        font-size: px2rem(14px);
        @include transition(color);

        &:hover{
          font-weight: $fontSemiBold;
          color: $primary;
        }
      }
    }
  }
}
</style>
